import { render, staticRenderFns } from "./ModalListaParidad.vue?vue&type=template&id=3fc55d64&scoped=true&"
import script from "./ModalListaParidad.vue?vue&type=script&lang=js&"
export * from "./ModalListaParidad.vue?vue&type=script&lang=js&"
import style0 from "./ModalListaParidad.vue?vue&type=style&index=0&id=3fc55d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc55d64",
  null
  
)

export default component.exports